module.exports = __webpack_public_path__ + "static/media/home.e6b99938.svg";